<script setup lang="ts">
import type { Component } from 'vue'
import { useRouter }  from '#imports'
import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useTaskStreamsStore } from '~/stores/taskStreams'
import useAuthStore from '~/stores/auth'
import { useTaskEventListener } from '~/composables/useTaskEventListener'
import { useAssignTask } from '~/composables/useAssignTask'
import { EXAM_TAG } from '~/composables/useAssignTags'
import TaskHeaderViewStudent from '~/views/TaskHeaderViewStudent.vue'
import FlytTaskView from '~/views/FlytTaskView.vue'
import ArticleView from '~/views/ArticleView.vue'
import AuSpinner from '~/components/ui/AuSpinner.vue'

const {
  contentType,
  locationId,
} = defineProps<{
  contentType: string
  locationId: number
}>()

const router = useRouter()
const { isTeacher } = storeToRefs(useAuthStore())
const { subscribeToTasks } = useTaskEventListener()
const { subscribedTaskIds } = storeToRefs(useTaskStreamsStore())
const { tasks, isLoading } = useAssignTask({ tags: [EXAM_TAG] })

const componentMap: Record<string, Component> = {
  pakke: TaskHeaderViewStudent,
  tekst: ArticleView,
  oppgave: FlytTaskView,
}

const task = computed(() => {
  const taskId = router.currentRoute.value.params.taskId
  return tasks.value?.find(task => task.taskId === taskId)
})
const componentToRender = computed(() => componentMap[contentType])

watch(tasks, () => {
  if (isTeacher.value)
    return
  if (!tasks.value?.length)
    return
  const tasksToSubscribe = tasks.value?.filter(task => !subscribedTaskIds.value.has(String(task.taskId)))
  if (tasksToSubscribe.length > 0) {
    subscribeToTasks(tasksToSubscribe)
  }
}, { immediate: true })
</script>

<template>
  <div
    v-if="isLoading"
    class="absolute inset-0 flex items-center justify-center"
  >
    <AuSpinner />
  </div>
  <component
    :is="componentToRender"
    v-else
    :location-id="locationId"
    v-bind="(componentToRender === TaskHeaderViewStudent && task) && { task }"
  />
</template>
